export default {
  default: {
    createButton: 'Create Award',
    sortAward: 'Sort Awards',
    title: 'Awards',
  },
}
